import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/tools/page';

export const Route = createFileRoute('/_app/settings/tools/')({
  component: Page,
});
